<template>
    <div v-if="assinatura && assinaturaMsg && assinatura.status_Pagamento_Texto !== 'Sem_aviso'" class="assinaturaMsg" :class="{'fundoLaranja' : assinatura.status_Pagamento_Texto === 'Vence_Em_Poucos_Dias'}">
      <p>
        <span v-if="assinatura.status_Pagamento_Texto === 'Bloquear_Entrada'"> Existe fatura em aberto de sua assinatura. </span>
        <span v-else-if="assinatura.status_Pagamento_Texto === 'Vence_Hoje'"> Sua fatura VENCE HOJE, evite bloqueio de acesso. </span>
        <span v-else-if="assinatura.status_Pagamento_Texto === 'Vence_Em_Poucos_Dias'"> Sua fatura vence EM POUCOS DIAS, evite bloqueio de acesso. </span>
        <a class="linkFatura" target="_blank" :href="`${assinatura.url_fatura}`"><u>Ver fatura</u></a>
        <button @click="fecharMsg" class="btn btn-link botaoFechar"><span class="fa fa-close"></span></button>
      </p>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      assinatura: state => state.auth.assinatura,
      assinaturaMsg: state => state.auth.assinaturaMsg
    })
  },
  methods: {
    ...mapActions({
      fecharMsgAssinatura: 'auth/fecharMsgAssinatura',
      mostrarMsgAssinatura: 'auth/mostrarMsgAssinatura'
    }),
    fecharMsg: function () {
      this.fecharMsgAssinatura()
    }
  }
}
</script>
<style scoped>
.assinaturaMsg{
  background-color: red;
  color: white;
  text-align: center;
  height: 5em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
}
.assinaturaMsg p{
  margin: 0;
  font-size: 20px;
}
.assinaturaMsg p a{
  color: white;
}
.linkFatura {
  margin-left:40px ;
}
.fundoLaranja {
  background-color: rgb(239, 87, 22)
}
.botaoFechar{
  position: absolute;
  right: 0px;
}
</style>


// WEBPACK FOOTER //
// msg-assinatura.vue?3a64d462